import type { IconProps } from '@phosphor-icons/react'
import {
  AppleLogo,
  Briefcase,
  CellTower,
  Cpu,
  IdentificationBadge,
  LockKey,
  ShieldCheck,
  ShieldWarning,
} from '@phosphor-icons/react'
import type { ImeiHubServiceId } from '@redevicer/shared'

export type { ImeiHubServiceId }

type Props = IconProps & {
  service: ImeiHubServiceId
}

/** Phosphor mapping — shared with mobile `imeiHubServicePhosphorIcon.tsx`. */
export default function ImeiHubServicePhosphorIcon({ service, ...iconProps }: Props) {
  switch (service) {
    case 'verify':
      return <ShieldCheck {...iconProps} />
    case 'passport':
      return <IdentificationBadge {...iconProps} />
    case 'lock':
      return <LockKey {...iconProps} />
    case 'carrier':
      return <CellTower {...iconProps} />
    case 'safecheck':
      return <ShieldWarning {...iconProps} />
    case 'business':
      return <Briefcase {...iconProps} />
    case 'android':
      return <Cpu {...iconProps} />
    case 'gsx':
      return <AppleLogo {...iconProps} />
    case 'tmobile':
      return <CellTower {...iconProps} />
    default:
      return <ShieldCheck {...iconProps} />
  }
}
